import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TestResultDto } from '../../shared/types/TestResultDto';
import { BehaviorSubject } from 'rxjs';
import { LevelTestResultsService } from '../level-test-results.service';

@Component({
  selector: 'lp2-level-test-results-section',
  templateUrl: './level-test-results-section.component.html',
  styleUrls: ['./level-test-results-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LevelTestResultsSectionComponent implements OnInit {
  testResults$ = new BehaviorSubject<TestResultDto[]>(null);


  constructor(private levelTestResultsService: LevelTestResultsService) { }

  ngOnInit() {
    this.levelTestResultsService.getTestResults().subscribe(results => this.testResults$.next(results));
  }
}



// WEBPACK FOOTER //
// ./ts/app/test-results/level-test-results-section/level-test-results-section.component.ts